<template>
  <div
    class="sm:block hidden fixed top-0 left-0 z-40 duration-300 border-b border-gray-100 shadow-xs bg-white w-full"
  >
    <div
      class="h-16 max-w-7xl mx-auto w-full flex items-center justify-between lg:px-5 px-2.5"
    >
      <div class="logo min-w-1/3">
        <NuxtLink :to="$localePath('/')" class="flex items-center text-2xl">
          <img src="@/assets/logo.webp" alt="Medium Logo" class="h-12" />
        </NuxtLink>
      </div>
      <NavbarNavsDesktop />
      <div class="sm:flex hidden items-center justify-end space-x-5 w-1/3">
        <button
          @click="store.openNewArtwork"
          :title="$t('nav.links.new_artwork')"
          type="button"
          class="flex items-center justify-center w-9 h-9 rounded-full bg-primary-blue/10 cursor-pointer overflow-hidden"
        >
          <Icon
            name="heroicons:plus"
            size="20"
            class="text-primary-blue animate-pulse scale-100 hover:scale-105"
          />
        </button>
        <NuxtLink
          :to="$localePath('/dashboard/notifications')"
          :title="$t('nav.links.notifications')"
          type="button"
          class="flex items-center justify-center w-9 h-9 rounded-full bg-primary-blue/10 cursor-pointer overflow-hidden"
        >
          <Icon
            name="heroicons:bell"
            size="20"
            class="text-primary-blue scale-100 hover:scale-105"
          />
        </NuxtLink>
        <NavbarLanguageSelect />
        <NavbarUser />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const store = useNewArtworkStore();
</script>
